export const environment = {
  production: false,
  srecApiUrl: 'https://apims-sprucepowermarketingdesk-dev.azure-api.net',
  srecApiKey: '80afe82a172e4980af7caee606111b37'
};